import { Button } from 'blaze-ui/Button'
import { ButtonProps } from 'blaze-ui/Button/Types'
import Styles from './Drawer.module.scss'
import cx from 'classnames'

export const Back = ({
  children = 'Back',
  onPress,
  frontIcon,
  variant = 'ghost',
  isDisabled,
  position = 'left',
}: Pick<ButtonProps, 'children' | 'onPress' | 'variant' | 'isDisabled' | 'frontIcon'> & {
  position?: 'left' | 'right'
}) => (
  <div className={cx(Styles.backButton, Styles[position])}>
    <Button frontIcon={frontIcon} variant={variant} onPress={onPress} rounded isDisabled={isDisabled}>
      {children}
    </Button>
  </div>
)

export const Action = Back
